import React from "react";
import { connect } from "react-redux";
import {getFeatureGroupName} from "../../../../../misc/helpers";
import {injectIntl} from "react-intl";
import {getFeatureGroupDescription} from "../groheFunctions";
import LookFeatureImage from "../../../lookNavigation/lookMain/lookFeature/lookFeatureImage";

const groheQuotingToolContent = (props) => {

  const {subParts, wizardStep, intl, fabricatorData, lookActiveFeature} = props;
  if (!subParts) {
    return null
  }

  const featureGroupName = getFeatureGroupName(subParts[wizardStep].part, intl, fabricatorData);
  const featureGroupDescription = getFeatureGroupDescription(subParts[wizardStep].part, intl, fabricatorData);

  return (
    <div className="grohe-quotingTool">
      <div className="grohe-section__title">
        {featureGroupName}
      </div>
      <div className="grohe-section__description grohe-quotingTool__description">
        {featureGroupDescription}
      </div>
      {lookActiveFeature ? (
        <div className="grohe-section__description">
          <LookFeatureImage/>
        </div>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookPageOpened, lookActiveFeature} = store.lookState;
  const {wizardStep} = store.groheQuotingToolState;
  return {
    lookActiveFeature,
    lookPageOpened,
    wizardStep,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(groheQuotingToolContent)
);
